import type { Money } from "../types";

interface Settings {
  maximumFractionDigits?: number;
  ceil?: boolean;
  minimumFractionDigits?: number;
}

// Give a total object {cents, currency} returns a formatted string
export const formatToCurrency = (
  total: Money | string | null,
  {
    maximumFractionDigits = 2,
    ceil = false,
    minimumFractionDigits
  }: Settings = {}
): string => {
  if (typeof total !== "object") return total;

  let totalInDollars = (total?.cents || 0) / 100;
  if (ceil) totalInDollars = Math.ceil(totalInDollars);

  const hasDecimal = minimumFractionDigits ? true : totalInDollars % 1 !== 0;

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency:
      total?.currency && typeof total.currency === "string"
        ? total.currency
        : "USD",
    maximumFractionDigits: hasDecimal ? maximumFractionDigits || 2 : 0,
    minimumFractionDigits
  });

  return formatter.format(totalInDollars);
};

export const toMoney = (
  value: number | string | null,
  maximumFractionDigits = 2
) => {
  if (value === null) return null;
  const hasDecimal = Number(value) % 1 !== 0;
  const USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: hasDecimal ? maximumFractionDigits || 2 : 0
  });
  return USDollar.format(Number(value));
};
